interface WorkModeIconProps {
  /** Edge length in px. Defaults to 24 to match the Figma export. */
  size?: number
  className?: string
  /** Accepted for parity with `lucide-react` icons; ignored — stroke
   *  widths are baked into the design. */
  strokeWidth?: number | string
}

/**
 * Branded icon for the "Wie ich arbeite" TopNav tab in Preferences. An
 * indigo-on-indigo briefcase silhouette — the warm-pastel sibling of
 * {@link AppExperienceIcon}, {@link AccountDataIcon}, and
 * {@link HelpAboutIcon}.
 *
 * Colors are baked in (`indigo-50` fill, `indigo-600` strokes) and don't
 * follow the theme palette — branded across all themes.
 *
 * @example
 * <WorkModeIcon size={24} />
 */
export function WorkModeIcon({ size = 24, className }: WorkModeIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path d="M12 12H12.01H12Z" fill="#EEF2FF" />
      <path
        d="M16 6V4C16 3.46957 15.7893 2.96086 15.4142 2.58579C15.0391 2.21071 14.5304 2 14 2H10C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4V6"
        fill="#EEF2FF"
      />
      <path
        d="M22 13C19.0328 14.959 15.5555 16.0033 12 16.0033C8.44445 16.0033 4.96721 14.959 2 13"
        fill="#EEF2FF"
      />
      <path
        d="M20 6H4C2.89543 6 2 6.89543 2 8V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8C22 6.89543 21.1046 6 20 6Z"
        fill="#EEF2FF"
      />
      <path
        d="M12 12H12.01M16 6V4C16 3.46957 15.7893 2.96086 15.4142 2.58579C15.0391 2.21071 14.5304 2 14 2H10C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4V6M22 13C19.0328 14.959 15.5555 16.0033 12 16.0033C8.44445 16.0033 4.96721 14.959 2 13M4 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V8C2 6.89543 2.89543 6 4 6Z"
        stroke="#4F46E5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
